export const MCP_CONNECTION_URL = "https://mcp.similarweb.com";
export const MCP_CONNECTION_GUID_URL = "https://docs.similarweb.com/api-v5/similarweb-mcp/available-integrations";
